export type ExpertInfo = {rating: number|string, roundedRating: string, "survey-count": number, specialties: string};
export type ExpertsResponse = Record<number, ExpertInfo>;

export default class ExpertInfoController {
	private static readonly resolvedExpertInformation = new Map<number, [number, ExpertInfo]>();
	private static resolutionQueue: Promise<void> = Promise.resolve();

	public static callWithExpertData(delegate: (response: ExpertsResponse) => void) {
		return ExpertInfoController.resolutionQueue = ExpertInfoController.resolutionQueue.then(() => {
			const displays = document.querySelectorAll(".expert-info-display:not(.set-up)");
			if (!displays.length) {
				return;
			}

			const postIds: number[] = [];
			for (const display of displays) {
				const postId = parseInt(display.getAttribute("data-post-id") ?? '0');
				if (postId && !postIds.includes(postId)) {
					postIds.push(postId);
				}
			}
			delegate(Object.fromEntries(postIds.map(pid => ExpertInfoController.resolvedExpertInformation.get(pid))
				.filter((expertInfo): expertInfo is [number, ExpertInfo] => expertInfo !== undefined)));
			const unresolvedPostIds = postIds.filter(pid => !ExpertInfoController.resolvedExpertInformation.has(pid));

			if (!unresolvedPostIds.length) {
				return;
			}

			const url = new URL(`/wp-json/plaudit/summitortho/v1/expert-info/${unresolvedPostIds.sort().join(',')}`, document.baseURI);
			return fetch(url, {method: 'POST'})
				.then<ExpertsResponse>(resp => resp.json())
				.then(json => {
					for (const [postId, expertInfo] of Object.entries(json)) {
						ExpertInfoController.resolvedExpertInformation.set(parseInt(postId), [parseInt(postId), expertInfo]);
					}
					delegate(json)
				});
		});
	}
}
